export const postfixes = {
  REQUEST: 'REQUEST',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
}

export function createRequestTypes(base, service) {
  return [postfixes.REQUEST, postfixes.SUCCESS, postfixes.FAILURE].reduce(
    (acc, type) => {
      acc[type] = `${service}_${base}_${type}`
      return acc
    },
    {},
  )
}

export function createAction(type, payload = {}) {
  return { type, payload }
}
